var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.517,
    height: 16,
    viewBox: "0 0 18.517 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M8,6.586,14.293.293a1,1,0,0,1,1.414,1.414l-7,7a1,1,0,0,1-1.414,0l-7-7A1,1,0,0,1,1.707.293Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(1547.758 1799) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1537.758 1799) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon_Chevron_Bottom_background",
    "data-name": "Icon/Chevron Bottom background",
    width: 8,
    height: 10,
    transform: "translate(4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Chevron_Bottom",
    "data-name": "Icon/Chevron Bottom",
    transform: "translate(7.769 2.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Grid",
    d: "M0,0H4.231V5.289H0Z",
    transform: "translate(-1.884)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Chevron_Bottom-2",
    "data-name": "Icon/Chevron Bottom",
    transform: "translate(-7.769 -1.855)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(-7 -11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_Fill_Accent",
    "data-name": "Icon/\\uD83D\\uDD8C Fill/Accent",
    d: "M0,0H30V30H0Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 15.002,
    transform: "translate(1530.242 1791.515)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.f9d8dfe8165c546664dd21e2416a2df8.svg";
export { ForwardRef as ReactComponent };